export function calcTaxIncludedPrice(price: number, taxPercentage = 10) {
  return Math.floor((price * (1 + (taxPercentage / 100))));
}
